// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-container {
  width: 30px;
  height: 20px;
  /* Default size for graph container */
}

.chart-title {
  font-size: 116px;
  font-weight: bold;
  /* Default font size for chart title */
}

.graphShow {
  width: 20px;
  height: 30px;
  /* Default size for graph show element */
}

canvas {
  width: 100%;
  /* Adjust canvas width to be responsive */
  height: auto;
  /* Let the height adjust automatically */
  max-width: 900px;
  /* Limit maximum width to prevent stretching */
  margin-left: auto;
  /* Center canvas horizontally */
  margin-right: auto;
  margin-top: 5%;
  /* Adjust margin top for spacing */
  z-index: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Css/DeliveryChart.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,8CAA8C;EAC9C,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,UAAU;AACZ","sourcesContent":[".graph-container {\r\n  width: 30px;\r\n  height: 20px;\r\n  /* Default size for graph container */\r\n}\r\n\r\n.chart-title {\r\n  font-size: 116px;\r\n  font-weight: bold;\r\n  /* Default font size for chart title */\r\n}\r\n\r\n.graphShow {\r\n  width: 20px;\r\n  height: 30px;\r\n  /* Default size for graph show element */\r\n}\r\n\r\ncanvas {\r\n  width: 100%;\r\n  /* Adjust canvas width to be responsive */\r\n  height: auto;\r\n  /* Let the height adjust automatically */\r\n  max-width: 900px;\r\n  /* Limit maximum width to prevent stretching */\r\n  margin-left: auto;\r\n  /* Center canvas horizontally */\r\n  margin-right: auto;\r\n  margin-top: 5%;\r\n  /* Adjust margin top for spacing */\r\n  z-index: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
